import { Layout } from 'antd';
import React from 'react';
import { Footer, Header } from 'antd/es/layout/layout';
import { Content } from 'antd/lib/layout/layout';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { FooterMain } from '../components/layout/FooterMain';

export const HeaderStyled = styled(Header)`
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  position: sticky;
  z-index: 100;
  top: 0px;
  left: auto;
  right: 0px;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
  background: rgb(255, 255, 255);
  -webkit-box-pack: start;
  justify-content: left;
  backdrop-filter: blur(4px);
`;

export const MainTemplatePage: React.FC = () => (
    <>
        <Layout style={{
          display: 'flex',
          minHeight: '100vh',
          margin: '0 auto',
        }}>
             {/* <HeaderStyled> */}
             {/*   <MainHeader/> */}
             {/* </HeaderStyled> */}
            <Content style={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column' }}>
                <div className="site-layout-content" style={{
                  display: 'flex', flex: '1', overflowY: 'auto', flexDirection: 'column',
                }}>
                    {/* {props.children} */}
                    <Outlet />
                </div>
            </Content>
            <Footer>
                <FooterMain/>
            </Footer>
        </Layout>
    </>
);
